import React, { FC, useContext } from 'react';
import { CartIcon, HamburgerNavIcon, ProfileIcon } from '../SvgIcon';
import { navigate } from 'gatsby';
import { UserContext } from '../../context/userContext';
import { ProfileContext } from '../../context/profileContext';
import { useCart } from '../../context/cartContext';
import { NavMenu, UserMenu } from './NavMenu';
import { MessagingContext } from '../../context/messageContext';

interface ResponsiveMenuProps {}

const UserButton: FC = () => {
  const {
    messageState: { unseen: count },
  } = useContext(MessagingContext);

  const {
    state: { isLoggedIn, initial, isHost, theme },
  } = useContext(UserContext);
  const {
    profileState: { avatar, username },
  } = useContext(ProfileContext);

  return (
    <button
      type="button"
      onClick={() => navigate('/webapp')}
      className="btn btn-ghost px-1 md:px-2 hover:bg-transparent"
    >
      <div className="text-secondary opacity-90 hover:opacity-100">
        <div className="indicator">
          {isLoggedIn && (avatar || initial) ? (
            <div className="avatar placeholder cursor-pointer">
              {avatar ? (
                <div className="w-6 outline outline-secondary outline-offset-1 rounded-full">
                  <img src={avatar} alt={username} />
                </div>
              ) : (
                <div className="bg-accent text-accent-content outline outline-secondary outline-offset-1 rounded-full w-6 flex">
                  <div className="text-lg/6 w-full text-center">{initial}</div>
                </div>
              )}
            </div>
          ) : (
            <ProfileIcon width={6} height={6} />
          )}
          {count && count > 0 ? (
            <span className="indicator-item indicator-bottom indicator-end badge badge-sm badge-accent">
              {count}
            </span>
          ) : (
            <span className="hidden indicator-item indicator-bottom indicator-end badge badge-sm badge-accent">
              {count}
            </span>
          )}
        </div>
      </div>
    </button>
  );
};

const ResponsiveMenu: FC<ResponsiveMenuProps> = () => {
  const { totalItems } = useCart();
  return (
    <div>
      <ul className="menu bg-base-100 menu-horizontal rounded-box mr-0">
        <li>
          <button
            type="button"
            className="btn btn-ghost px-1 md:px-2 hover:bg-transparent hover:border-transparent"
            onClick={() => navigate('/cart')}
          >
            <div className="indicator group">
              <span className="text-secondary opacity-90 group-hover:opacity-100">
                <CartIcon width={6} height={6} />
              </span>
              {totalItems > 0 && (
                <span className="indicator-item indicator-bottom indicator-end badge badge-sm badge-accent opacity-90 group-hover:opacity-100">
                  {totalItems}
                </span>
              )}
            </div>
          </button>
        </li>
        <li>
          {/* <UserButton /> */}
          <UserDropdown />
        </li>
        <li className="dropdown dropdown-end">
          <div
            tabIndex={1}
            role="button"
            className="btn btn-ghost px-1 md:px-2 ml-0 hover:bg-transparent"
            aria-label="Main Menu"
            aria-controls="dropdown-menu"
          >
            <span className="text-secondary opacity-90 hover:opacity-100">
              <HamburgerNavIcon width={7} height={7} />
            </span>
          </div>
          <NavMenu />
        </li>
      </ul>
    </div>
  );
};

const UserDropdown: FC = () => {
  const {
    messageState: { unseen: count },
  } = useContext(MessagingContext);

  const {
    state: { isLoggedIn, initial },
  } = useContext(UserContext);
  const {
    profileState: { avatar, username },
  } = useContext(ProfileContext);
  return (
    <div className="dropdown dropdown-end p-0 rounded-full my-auto mx-2 pt-1">
      <div tabIndex={0} role="button">
        <div className="flex text-secondary opacity-90 hover:opacity-100 items-center">
          <div className="indicator">
            {isLoggedIn && (avatar || initial) ? (
              <div className="avatar placeholder cursor-pointer">
                <div className="bg-accent text-accent-content outline outline-secondary outline-offset-1 rounded-full flex w-6 h-6">
                  {avatar ? (
                    <img src={avatar} alt={username} />
                  ) : (
                    <div className="text-lg/6 w-full text-center">
                      {initial}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <ProfileIcon width={6} height={6} />
            )}
            {count && count > 0 ? (
              <span className="indicator-item indicator-bottom indicator-end badge badge-sm badge-accent">
                {count}
              </span>
            ) : (
              <span className="hidden indicator-item indicator-bottom indicator-end badge badge-sm badge-accent">
                {count}
              </span>
            )}
          </div>
        </div>
      </div>
      <UserMenu />
    </div>
  );
};
export { ResponsiveMenu, UserDropdown };
